// @flow
// Komponenty pouzite primarne v eshopu (odkomentujte v pripade eshopu, ale pozor obsahuje i univerzalne pouzitelne komponenty, pokud potrebujete, nebojte se pouzit - tj. presunout sem)
import configureEshopComponents from './configureEshopComponents';

export default (props) => {
  switch (props.decorator || props.is) {
    case 'AddSvgIconSprite':
      return import('./components/AddSvgIconSprite');
    case 'WebLayout':
      return import('./components/WebLayout');
    case 'ContentChecker':
      return import('./components/ContentChecker');
    case 'FooterHandler':
      return import('./components/FooterHandler');
    case 'SimpleCollapse':
      return import('./components/SimpleCollapse');
    case 'ProductTypeSimpleCollapse':
      return import('./components/ProductTypeSimpleCollapse');
/*    case 'ExtendedFilters':
      return import('./components/ExtendedFilters');*/
    case 'FilterContents':
      return import('./components/FilterContents');
    // case 'GreedyMenu':
      // return GreedyMenu;
    case 'Typeahead':
      // COMMON: Komponenta obecneho naseptavace (odeberte, pokud nepouzivate RJ komponentu typeahead nebo v eshopu vychozi naseptavace pobocek dopravnich spolecnosti)
      return import('fg-frontend/components/Typeahead');
    case 'Tabs':
      return import('./components/Tabs');
    case 'SelectDesign':
      return import('./components/SelectDesign');
    case 'SubmenuToggle':
      return import('./components/SubmenuToggle');
    case 'FulltextHandler':
      return import('./components/FulltextHandler');
    case 'BasketTabs':
      return import('./components/BasketTabs');
    case 'PasswordToggle':
      // COMMON: Komponenta pro zapnuti/vypnuti viditelnosti vkladaneho hesla (odeberte, pokud nepouzivate registration modul)
      return import('fg-frontend/components/PasswordToggle');
    case 'SocialShare':
      // COMMON: Komponenta pro sdileni linku na socialni site (odeberte, pokud nepouzivate sdileni linku na socialni site, napr. v eshopu v detailu produktu)
      return import('fg-frontend/src/components/SocialShare');
    case 'Slider':
      return import('fg-frontend/components/Slider');
    case 'UniversalPaginationButton':
      return import('./components/UniversalPaginationButton');
    case 'Tooltip':
      // COMMON: Napovedne popupy (odeberte, pokud v projektu nepouzivate, na eshopu napriklad na napovedy k parametrum a jako obecna knihovna pro zobrazovani napovednych textu)
      return import('./components/Tooltip');
    case 'GtmHandler':
      // COMMON: Komponenta, ktera upoznuje posilat do GTM Datalayeru zaznamu na zaklade zapisu v data atributech (odeberte, pokud GTM nepouzivate, jinak vyuzito primarne v eshopu)
      return import('./components/GtmHandler');
    case 'TriggerInViewport':
      // COMMON: Komponenta, ktera vystreli specialni udalost v okamziku, kdy se objevi ve viewportu (pomocna komponenta pro GtmHandler, odeberte, pokud nepouzivate GTMHandler]
      return import('./components/TriggerInViewport');
    case 'PhotoSwipe':
      return import('./components/PhotoSwipe');
    case 'ContentSlider':
      return import('./components/ContentSlider');
   case 'LazyImage':
     // COMMON: Komponenta, ktera nastavi obrazek do rezimu lazy (odeberte, pokud nepouzivate lazy obrazky)
     return import('./components/LazyImage');
    case 'Webslider':
      return import('fg-frontend/src/components/Webslider');
    case 'Countdown':
      return import('./components/Countdown');
    case 'Toggler':
      // COMMON: Komponenta pro prepinani HTML tridy na danem elementu
      return import('./components/Toggler');
    case 'PrintPage':
      return import('fg-frontend/src/components/PrintPage');
    case 'FGUpload':
      // COMMON: Komponenta pro multi upload souboru (odeberte, pokud nepouzivate RJ fileUpload komponentu)
      return import('./components/FGUpload');
    case 'RangeSlider':
      return import('fg-frontend/src/components/RangeSlider');
    case 'FulltextResultsAnchors':
      return import('./components/FulltextResultsAnchors');
    case 'CitationBox':
      return import('./components/CitationBox');
    case 'GoogleRecaptcha':
      // COMMON: Google Recaptcha (odeberte pokud neupouzivate komponentu Google Recaptcha)
      return import('fg-frontend/src/components/GoogleRecaptcha');
    default:
      const eshopComponent = configureEshopComponents(props);
      if (eshopComponent) {
        return eshopComponent;
      } else {
        console.log(`Unknown component ${props.decorator || props.is}`);
        return null;
      }
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWebComponents.js